import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import ManageTeamCustomerTable from '../../components/ManageTeam/ManageTeamCustomerTable';
import "../../components/CommunicationTemplete/CommunicationTemplate.css";


const defaultTheme = createTheme();

const ManageCustomerTeam = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Manage Teams</h1>
          <p>Create teams, assign leaders, and manage members.</p>
        </div>
      </div>

      <ManageTeamCustomerTable />
    </ThemeProvider>
  );
};

export default ManageCustomerTeam;